import React from "react";
import {
  CONFIRMATION_HEADER,
  CONFIRMATION_MESSAGE,
  PREFERED_LANGUAGE_KEYS,
} from "../../../App.config";
const LanguageConfirmationPopUpModalComponent = (props) => {
  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div >
          {/* <h5 className="modal-title" id="exampleModalLabel">
            {CONFIRMATION_HEADER}
          </h5> */}
          <button
            type="button"
            className="close"
            onClick={() => {
              props.closeRemoveModal();
            }}
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>{CONFIRMATION_MESSAGE} </span>
        </div>
        <div className="modal-footer">
          <button
            onClick={() => {
              props.onLanguageSelection(PREFERED_LANGUAGE_KEYS.EnglishUS);
            }}
            type="button"
            className="btn btn-primary"
          >
            English
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-dismiss="modal"
            onClick={() =>
              props.onLanguageSelection(PREFERED_LANGUAGE_KEYS.FrenchCanada)
            }
          >
            French
          </button>
        </div>
      </div>
    </div>
  );
};
export default LanguageConfirmationPopUpModalComponent;
